import React from 'react'

const Seperator = ({text = "成功"}) => {

    return ( 
        <div className='seperator'>
            <span/>
            <p> {text} </p>
            <span/>
        </div> 
    );
}
 
export default Seperator;